// extracted by mini-css-extract-plugin
module.exports = {"card":"s_g"};